import { W as WuiTextarea$1, d as defineCustomElement$1 } from './p-DbilP0RW.js';

const WuiTextarea = WuiTextarea$1;
const defineCustomElement = defineCustomElement$1;

export { WuiTextarea, defineCustomElement };
